import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {AppointmentsFlowStateService} from '../../common/service/appointments-flow-state.service';
import {
  AppointmentSummaryCardComponent
} from '../appointments-shared/appointment-summary-card/appointment-summary-card.component';

@Component({
  selector: 'app-appointments-success',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatCardModule, MatIconModule, AppointmentSummaryCardComponent],
  templateUrl: './appointments-success.component.html',
  styleUrls: ['./appointments-success.component.scss']
})
export class AppointmentsSuccessComponent {
  patientEntryMessage: string | null = null;

  constructor(
    public flowState: AppointmentsFlowStateService,
    private router: Router
  ) {}

  continueToPatientForms() {
    const patientEntryUrl = this.flowState.snapshot.bookingConfirmation?.patientEntryUrl;
    if (!patientEntryUrl) {
      this.patientEntryMessage = 'Die Weiterleitungsadresse konnte nicht geladen werden.';
      return;
    }
    window.location.assign(patientEntryUrl);
  }

  startNewBooking() {
    this.flowState.clearAll();
    this.router.navigate(['/vorauswahl']);
  }
}
